const tinycolor = require('tinycolor2');

export const isLight = (color: string) => tinycolor(color).isLight();
export const isDark = (color: string) => tinycolor(color).isDark();
export const toHex = (color: string) => tinycolor(color).toHexString();
export const toRgb = (color: string) => tinycolor(color).toRgbString();

export const rgbToHex = toHex;
export const hexToRgb = toRgb;
